export default __webpack_public_path__ + "static/media/logo-livereel.3d3d5db6.png";